export default __webpack_public_path__ + "static/media/forgot-password-bg@2x.a0e93d20.png";